// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".registration-button[data-v-1be16c54]{padding-left:15px;padding-right:15px}", ""]);
// Exports
module.exports = exports;
